<template>
  <section id="usps" class="usps-section" aria-labelledby="usps-heading">
    <div class="max-w-screen-xl mx-auto px-6">

      <div class="usps-layout">

        <!-- Links: vaste introkolom -->
        <div class="usps-intro">
          <span class="usps-eyebrow">Waarom Plug2Charge</span>
          <h2 id="usps-heading" class="usps-title">Duurzaam beginnen was nog nooit zo makkelijk</h2>
          <p class="usps-body">Wij leveren complete oplossingen zodat jij direct kunt beginnen met besparen, zonder gedoe.</p>
          <router-link to="/hoe-het-werkt" class="usps-cta-link">
            <i class="bi bi-question-circle" aria-hidden="true"></i>
            Hoe het werkt
            <svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 8h10M9 4l4 4-4 4"/></svg>
          </router-link>
        </div>

        <!-- Rechts: 2×2 USP grid -->
        <ul class="usps-grid" role="list">
          <li
            v-for="(usp, i) in usps"
            :key="usp.title"
            class="usp-item"
          >
            <div class="usp-num">{{ String(i + 1).padStart(2, '0') }}</div>
            <div class="usp-icon-wrap" aria-hidden="true">
              <i :class="`bi ${usp.icon}`"></i>
            </div>
            <h3 class="usp-title">{{ usp.title }}</h3>
            <p class="usp-body">{{ usp.body }}</p>
          </li>
        </ul>

      </div>
    </div>
  </section>
</template>

<script setup>
const usps = [
  {
    icon: 'bi-lightning-charge',
    title: 'Plug & Play installatie',
    body: 'Onze balkonsets installeer je zelf in 30 minuten. Geen elektricien, geen gedoe.',
  },
  {
    icon: 'bi-sun',
    title: '100% duurzame merken',
    body: 'Alleen A-merken: Hoymiles, Aiko, Growatt, Victron. Spullen die 25 jaar meegaan.',
  },
  {
    icon: 'bi-headset',
    title: 'Technisch advies inbegrepen',
    body: 'Gratis advies van energiespecialisten via mail of live chat. We reageren snel.',
  },
  {
    icon: 'bi-truck',
    title: 'Bestel voor 15:00 → morgen thuis',
    body: 'Uit eigen voorraad geleverd. Gratis verzending vanaf €50, altijd met track & trace.',
  },
]
</script>

<style scoped>
.usps-section {
  padding: 5rem 0;
  background: #fff;
}

.usps-layout {
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  gap: 5rem;
  align-items: start;
}

/* ── Intro kolom ── */
.usps-intro {
  position: sticky;
  top: 120px;
}

.usps-eyebrow {
  display: inline-block;
  background: rgba(255, 213, 0, 0.15);
  color: #7a5f00;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 0.3rem 1rem;
  border-radius: 50px;
  border: 1px solid rgba(255, 213, 0, 0.3);
  margin-bottom: 1.25rem;
}

.usps-title {
  font-size: clamp(1.625rem, 3vw, 2.25rem);
  font-weight: 900;
  color: #111;
  line-height: 1.15;
  letter-spacing: -0.02em;
  margin: 0 0 1.25rem;
  text-wrap: balance;
}

.usps-body {
  font-size: 1.0625rem;
  color: #555;
  line-height: 1.7;
  margin: 0 0 2rem;
}

.usps-cta-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 700;
  font-size: 0.9375rem;
  color: #111;
  text-decoration: none;
  border-bottom: 2px solid #FFD500;
  padding-bottom: 2px;
  transition: gap 0.2s;
}
.usps-cta-link:hover { gap: 0.75rem; }

/* ── USP grid ── */
.usps-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
  list-style: none;
  padding: 0;
  margin: 0;
}

.usp-item {
  background: #f8f8f8;
  border-radius: 16px;
  padding: 1.875rem;
  position: relative;
  transition: box-shadow 0.2s, transform 0.2s;
}
.usp-item:hover {
  box-shadow: 0 8px 28px rgba(0,0,0,0.07);
  transform: translateY(-2px);
}

.usp-num {
  font-size: 0.72rem;
  font-weight: 800;
  color: #666;
  letter-spacing: 0.06em;
  margin-bottom: 1rem;
  font-variant-numeric: tabular-nums;
}

.usp-icon-wrap {
  width: 44px;
  height: 44px;
  background: #111;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.125rem;
  font-size: 1.25rem;
  color: #FFD500;
}

.usp-title {
  font-size: 1rem;
  font-weight: 800;
  color: #111;
  margin: 0 0 0.625rem;
  line-height: 1.3;
}

.usp-body {
  font-size: 0.875rem;
  color: #666;
  line-height: 1.65;
  margin: 0;
}

/* ── Responsive ── */
@media (max-width: 1023px) {
  .usps-layout {
    grid-template-columns: 1fr;
    gap: 2.5rem;
  }
  .usps-intro { position: static; }
  .usps-title { font-size: 1.75rem; }
}

@media (max-width: 640px) {
  .usps-grid { grid-template-columns: 1fr; gap: 1rem; }
  .usp-item { padding: 1.375rem; }
}

@media (prefers-reduced-motion: reduce) {
  .usp-item { transition: none; }
}
</style>
